export const COMPS_ROOT_NAMESPACE = 'comps-root'
export const SVG_STORE_NAMESPACE = 'svgStore'
export const CUSTOM_CSS_STORE_NAMESPACE = 'customCssStore'

export const PARSED_SVG_ASPECT = 'parsedSvg'
export const CUSTOM_CSS_BY_ID_ASPECT = 'customCssById'
